// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__uIrgg","addWidgetButton":"Header_addWidgetButton__1t1sh","dashboardTabs":"Header_dashboardTabs__Bul91","active":"Header_active__QEj93"};